// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { IconWrapper } from "@insite/mobius/Icon";
import { productCardStyles } from "@pace/Overrides/Widgets/ProductList/ProductListProductCard";
import { constants } from "@pace/XDL/constants";
import { mergeWithCss, sharedBadgeStyle, xScreen } from "@pace/XDL/Utilities";
import { css } from "styled-components";

const partNumberAndAttributeStyles = {
    css: css`
        max-width: 197px;
        ${xScreen("lte", constants.productList.breakpoints.md)} {
            max-width: 100%;
        }
    `,
};

productCardStyles.gridContainer = {
    css: css`
        display: grid;
        grid-template-columns: 132px minmax(0, 514px) 317px;
        grid-column-gap: 12px;
        padding: 5px 0;
        ${xScreen("gte", "xl")} {
            grid-template-columns: 132px minmax(0, 675px) 317px;
        }
        ${xScreen("lte", constants.productList.breakpoints.md)} {
            grid-template-columns: 91px minmax(0, 1fr);
            grid-row-gap: 12px;
            height: 100%;
        }
    `,
};
productCardStyles.leftColumnGridItem = {
    css: css`
        grid-column: 1 / 2;
        grid-row: 1 / 5;
    `,
};

productCardStyles.infoGridItem = {
    css: css`
        grid-column: 2 / 3;
        grid-row: 1 / 5;
        padding-right: 8px;
        ${xScreen("lte", constants.productList.breakpoints.md)} {
            padding-right: 0;
        }
    `,
};
productCardStyles.actionsGridItem = {
    css: css`
        grid-column: 3 / 4;
        grid-row: 1 / 6;
        ${xScreen("lte", constants.productList.breakpoints.md)} {
            grid-column: 1 / 3;
            grid-row: 5 / 6;
            margin-top: auto;
        }
    `,
};
productCardStyles.searchScoreDataGridItem = {
    css: css`
        grid-column: 1 / 4;
        grid-row: 6 / 7;
        min-height: 28px;
        &:empty {
            display: none;
        }
        ${xScreen("lte", constants.productList.breakpoints.md)} {
            grid-column: 2 / 3;
        }
    `,
};

productCardStyles.productPriceAndActionsStyles = {
    productGridContainer: {
        container: {
            css: css`
                ${xScreen("lte", "md")} {
                    max-width: 100%;
                }
                ${xScreen("lte", "sm")} {
                    max-width: 100%;
                }
            `,
        },
        addToList: {
            css: css`
                display: flex;
            `,
        },
    },
    productListProductImageStyles: {
        compareCheckbox: {
            css: css`
                padding: 0;
            `,
        },
        compareCheckboxWrapper: {
            css: css`
                line-height: 1;
                width: max-content;
            `,
        },
    },
    replacementWrapper: {
        css: css`
            display: flex;
            min-height: 17px;
            height: 17px;
            margin-left: auto;

            ${xScreen("gte", constants.cartLine.breakpoints.md)} {
                &:empty {
                    display: none;
                }
            }

            ${xScreen("lte", constants.cartLine.breakpoints.md)} {
                max-height: 17px;
            }

            ${xScreen("lte", "xs")} {
                &:empty {
                    display: none;
                }
            }
        `,
    },
};

productCardStyles.productInformationStyles = {
    attributes: {
        container: {
            offsetCss: css`
                margin-top: 12px;
                max-width: 402px;
                gap: 4px 8px;
            `,
        },
        attributeTypeGridItem: {
            ...partNumberAndAttributeStyles,
        },
        attributeValueGridItem: {
            ...partNumberAndAttributeStyles,
        },
    },
    partNumbersStyles: {
        container: {
            gap: 8,
            offsetCss: css`
                max-width: 402px;
            `,
        },
        customerNameGridItem: {
            ...partNumberAndAttributeStyles,
        },
        erpNumberGridItem: {
            ...partNumberAndAttributeStyles,
        },
        manufacturerItemGridItem: {
            ...partNumberAndAttributeStyles,
        },
    },
};

productCardStyles.productListProductImage = {
    ...productCardStyles.productListProductImage,
    badgeContainer: {
        ...mergeWithCss(sharedBadgeStyle.badge, {
            css: css`
                flex-wrap: nowrap;

                & ${IconWrapper} {
                    opacity: 0.66;
                }
            `,
        }),
    },
};
